var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "m-2" },
    [
      _c("el-card", { style: { width: _vm.widthCard } }, [
        _vm.titulo
          ? _c("div", [
              _c("h3", { staticClass: "titulo" }, [_vm._v(_vm._s(_vm.titulo))]),
              _vm._v(" "),
              _c("hr")
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "cards" }, [
          _c(
            "div",
            _vm._l(Object.keys(this.objeto), function(key, index) {
              return _vm.objeto[key]
                ? _c("p", { key: index }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.formataLabel(key)) +
                        ": " +
                        _vm._s(_vm.objeto[key]) +
                        "\n        "
                    )
                  ])
                : _vm._e()
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "actionButtons" },
            [
              _vm.deletar
                ? _c("CustomButton", {
                    attrs: { type: "ErrorButton", icon: "fa fa-trash" },
                    on: { click: _vm.deletar }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.editar
                ? _c("CustomButton", {
                    attrs: { icon: "fa fa-pencil-alt" },
                    on: { click: _vm.editar }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b7415b96", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7415b96","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Cards/Card/Card.vue
// module id = null
// module chunks = 